import {
  Component, AfterViewInit, OnDestroy, ElementRef, ViewChild
} from '@angular/core';

interface Product {
  n: string;
  title: string;
  desc: string;
  fragment: string;
}

@Component({
  selector: 'app-products-gallery',
  templateUrl: './products-gallery.component.html',
  styleUrls: ['./products-gallery.component.scss']
})
export class ProductsGalleryComponent implements AfterViewInit, OnDestroy {
  @ViewChild('track', { static: true }) trackRef!: ElementRef<HTMLElement>;
  @ViewChild('viewport', { static: true }) viewportRef!: ElementRef<HTMLElement>;
  @ViewChild('fade', { static: true }) fadeRef!: ElementRef<HTMLElement>;

  products: Product[] = [
    { n: '01', title: 'Apps', desc: 'Aplicativos sob medida, rápidos e prontos pra escalar.', fragment: 'apps' },
    { n: '02', title: 'Sites', desc: 'Sites empresariais que passam credibilidade e convertem.', fragment: 'sites-empresariais' },
    { n: '03', title: 'Landing Pages', desc: 'Páginas de alta conversão para as suas campanhas.', fragment: 'landing-pages' },
    { n: '04', title: 'Lojas Virtuais', desc: 'E-commerces completos, prontos pra vender.', fragment: 'lojas-virtuais' },
    { n: '05', title: 'Design & Identidade', desc: 'Marca e visual que destacam o seu negócio.', fragment: 'design-identidade' }
  ];

  constructor(private host: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  /** Converte o scroll vertical (no track alto) em deslocamento horizontal da galeria. */
  private onScroll = (): void => {
    const rect = this.host.nativeElement.getBoundingClientRect();
    const total = rect.height - window.innerHeight;
    const p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
    const track = this.trackRef.nativeElement;
    const maxX = track.scrollWidth - this.viewportRef.nativeElement.clientWidth;
    track.style.transform = `translate3d(${-(p * maxX).toFixed(1)}px, 0, 0)`;

    // Véu branco desativado: a galeria sobe mostrando os cards (preenche a transição)
    this.fadeRef.nativeElement.style.opacity = '0';
  };
}
